/*
 * @Author: caiqin.xie
 * @since: 2023-08-16 18:26:30
 * @lastTime: 2023-11-06 15:23:22
 * @LastEditors: caiqin.xie
 * @message: banner位置常量
 */

// 博客列表banner
export const BLOGLISTPOS = '1674674931708833793';
// 博客列表banner2
export const BLOGLISTPOS2 = '1674674931708833806';
// 博客列表banner3
export const BLOGLISTPOS3 = '1674674931708833807';
// 博客详情banner
export const BLOGDETAILPOS = '1674674931708833797';
// 服务支持主页banner
export const SUPPORTPOS = '1674674931708834001'
// 服务支持主页二级banner
export const SUPPORTSECONDPOS = '1674674931708834002'
// 门店banner
export const SHOPPOS = '1674674931708834003'
// 权益查询banner
export const BENEFITSPOS = '1674674931708833794'
// 维修流程banner
export const REPAIRPROCESSPOS = '1674674931708833796'
// 关于banner
export const ABOUTUSPOS = '1674674931708833795'

// 首页banner
export const HOMEBANNER1 = "1674674931708833798" //banner1 位置 id
export const HOMEBANNER2 = "1674674931708833799" //banner2 位置 id
export const HOMEBANNER3 = "1674674931708833801" //banner3 位置 id
export const HOMEBANNER4 = "1674674931708833804" //banner4 位置 id
export const HOMEBANNER5 = "1674674931708833805" //banner5 位置 id
// 配件banner
export const ACCESSORYPOS = '1674674931708833802'
//软件banner
export const SOFTWAREPOS = '1674674931708833803'
